
import React, { useState } from 'react';
import Navbar from '../components/NavbarLanding';
import Footer from './Footer';
import questionMark from '../assets/question mark.png';
import happyUsersIcon from '../assets/people frame.png';
import accuracyIcon from '../assets/badge.png';
import supportIcon from '../assets/timer.png';
import personalityIcon from '../assets/Brain frame.png';
import triangle from '../assets/triangle.png';
import gettingStartedIcon from '../assets/question mark.png';
import rectangleShape from '../assets/rectangle shape.png';

function ResultsAccordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const resultsFaqs = [
    {
      question: 'What information is included in my personality report?',
      answer: 'Your report includes your personality type, strengths, areas for growth, and personalized insights.'
    },
    {
      question: 'Can my personality type change over time?',
      answer: 'While core traits are stable, some aspects can evolve with experiences and self-development.'
    },
    {
      question: 'How should I interpret my results?',
      answer: 'Use your results as a guide for self-awareness and personal growth, not as a strict label.'
    },
    {
      question: 'Can I share my results with others?',
      answer: 'Yes, you can share your results with friends, family, or colleagues.'
    },
  ];
  
  return (
    <div className="space-y-4 ">
      {resultsFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white max-w-8xl rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

const faqs = [
  {
    question: 'What is AI Powered Personality?',
    answer: 'It is a platform that delivers personalized AI-driven experiences for users.'
  },
  {
    question: 'How do I get started?',
    answer: 'Simply click the Get Started button on the Home page and follow the instructions.'
  },
  {
    question: 'Is my data secure?',
    answer: 'Yes, we use industry-standard security practices to protect your data.'
  },
  // Add more FAQs as needed
];

function Accordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const gettingStartedFaqs = [
    {
      question: 'How long does the personality test take?',
      answer: 'The test typically takes about 8-10 minutes to complete.'
    },
    {
      question: 'Is the personality test really free?',
      answer: 'Yes, our personality test is completely free for all users.'
    },
    {
      question: 'Do I need to create an account to take the test?',
      answer: 'No account is required to take the test, but creating one lets you save your results.'
    },
    {
      question: 'Can I retake the test if I’m not satisfied with my results?',
      answer: 'Yes, you can retake the test as many times as you like.'
    },
  ];
  return (
    <div className="space-y-4">
      {gettingStartedFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

function AboutTestAccordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const aboutTestFaqs = [
    {
      question: 'What makes your test different from other personality tests?',
      answer: 'Our test uses advanced AI algorithms and a unique model to provide more accurate and personalized results.'
    },
    {
      question: 'How accurate is the personality test?',
      answer: 'Our test has a 94% accuracy rate, validated by thousands of users and ongoing research.'
    },
    {
      question: 'What are the 13 personality types?',
      answer: 'The 13 types are based on our proprietary model, each representing a unique set of traits and behaviors.'
    },
    {
      question: 'Is this test based on scientific research?',
      answer: 'Yes, our test is grounded in scientific research and regularly updated with the latest findings.'
    },
  ];
  return (
    <div className="space-y-4">
      {aboutTestFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

function CertificationAccordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const certificationFaqs = [
    {
      question: 'Is your personality test certified?',
      answer: 'Our test is based on validated psychological models and is trusted by professionals, but it is not formally certified by a regulatory body.'
    },
    {
      question: 'How do you ensure the accuracy of the results?',
      answer: 'We use advanced AI and continuous data analysis to maintain a high accuracy rate for all users.'
    },
    {
      question: 'Can I use my results for professional purposes?',
      answer: 'While our results are highly accurate, we recommend consulting a professional for official use.'
    },
  ];
  return (
    <div className="space-y-4">
      {certificationFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

const FAQ = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="min-h-screen w-full flex flex-col bg-gradient-to-br from-[#EFF6FF] via-white to-[#F9FAFB]">
      <Navbar />
      <main className="flex-1 w-full max-w-8xl mx-auto py-6 px-2" style={{ minWidth: 0 }}>
      <div className="flex justify-center mb-10">
        <div
          className="flex items-center gap-2 px-4 sm:px-6"
          style={{
            width: '100%',
            maxWidth: 297,
            height: '30px',
            borderRadius: '9999px',
            background: 'linear-gradient(90deg, #e0f0ff 0%, #f8e6ff 100%)',
            border: '1px solid #e0e7ff',
            opacity: 1,
          }}
        >
          <img src={questionMark} alt="FAQ" style={{ width: 20, height: 20 }} />
          <span className="text-base font-medium text-gray-700" style={{lineHeight: '30px'}}>Frequently Asked Questions</span>
        </div>
      </div>
      <div className="relative mb-8">
        <img
          src={triangle}
          alt=""
          className="absolute left-0 top-2 w-6 h-6 opacity-60"
          style={{ left: '-32px' }}
        />
        
        <h1
          className="text-3xl sm:text-5xl font-extrabold text-center mb-4"
          style={{ fontFamily: 'Roboto Slab, serif' }}
        >
          Got Questions? We&apos;ve Got
        </h1>
        <p className="text-center" style={{ fontFamily: 'Roboto Slab, serif', fontWeight: 400, color: '#475569' }}>
          Find answers to the most common questions about our personality test, results, and platform.
        </p>
        <p className="text-center" style={{ fontFamily: 'Roboto Slab, serif', fontWeight: 400, color: '#475569' }}>
          Can&apos;t find what you&apos;re looking for? Our support team is here to help!
        </p>
      </div>
      {/* FAQ stats boxes section */}
      <div className="flex  justify-center gap-4 sm:gap-6 mt-10 mb-8 px-2 md:px-4 lg:px-8" style={{minHeight: 170}}>
        {/* Happy Users */}
        <div className="flex flex-col items-center justify-center" style={{background: '#F3E5F5', borderRadius: '16px', width: 350, height: 150, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.07)', marginLeft: 8, marginRight: 8}}>
          <span className="flex items-center justify-center w-12 h-12 rounded-lg mb-2" style={{background: '#CE93D8'}}>
            <img src={happyUsersIcon} alt="Happy Users" style={{width: 32, height: 32, objectFit: 'contain', filter: 'brightness(0) invert(1)'}} />
          </span>
          <span className="text-2xl font-extrabold" style={{fontFamily: 'Roboto Slab, serif'}}>2M+</span>
          <span className="text-gray-600 text-sm" style={{fontFamily: 'Roboto Slab, serif'}}>Happy Users</span>
        </div>
        {/* Accuracy Rate */}
        <div className="flex flex-col items-center justify-center" style={{background: '#E3F2FD', borderRadius: '16px', width: 350, height: 150, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.07)', marginLeft: 8, marginRight: 8}}>
          <span className="flex items-center justify-center w-12 h-12 rounded-lg mb-2" style={{background: '#B6D5FA'}}>
            <img src={accuracyIcon} alt="Accuracy Rate" style={{width: 32, height: 32, objectFit: 'contain'}} />
          </span>
          <span className="text-2xl font-extrabold" style={{fontFamily: 'Roboto Slab, serif'}}>94%</span>
          <span className="text-gray-600 text-sm" style={{fontFamily: 'Roboto Slab, serif'}}>Accuracy Rate</span>
        </div>
        {/* Support Available */}
        <div className="flex flex-col items-center justify-center" style={{background: '#FFF3E0', borderRadius: '16px', width: 350, height: 150, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.07)', marginLeft: 8, marginRight: 8}}>
          <span className="flex items-center justify-center w-12 h-12 rounded-lg mb-2" style={{background: '#FFD88D'}}>
            <img src={supportIcon} alt="Support Available" style={{width: 32, height: 32, objectFit: 'contain'}} />
          </span>
          <span className="text-2xl font-extrabold" style={{fontFamily: 'Roboto Slab, serif'}}>24/7</span>
          <span className="text-gray-600 text-sm" style={{fontFamily: 'Roboto Slab, serif'}}>Support Available</span>
        </div>
        {/* Personality Types */}
        <div className="flex flex-col items-center justify-center" style={{background: '#E8F5E8', borderRadius: '16px', width: 350, height: 150, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.07)', marginLeft: 8, marginRight: 8}}>
          <span className="flex items-center justify-center w-12 h-12 rounded-lg mb-2" style={{background: '#A5D6A7'}}>
            <img src={personalityIcon} alt="Personality Types" style={{width: 32, height: 32, objectFit: 'contain', filter: 'brightness(0) invert(1)'}} />
          </span>
          <span className="text-2xl font-extrabold" style={{fontFamily: 'Roboto Slab, serif'}}>13</span>
          <span className="text-gray-600 text-sm" style={{fontFamily: 'Roboto Slab, serif'}}>Personality Types</span>
        </div>
      </div>

      {/* FAQ search bar section */}
      <div className="flex justify-center w-full mb-10 px-2 md:px-4 lg:px-8">
        <div style={{
          background: '#FFFDE7',
          borderRadius: '16px',
          height: '40px',
          width: '100%',
          maxWidth: '900px',
          display: 'flex',
          alignItems: 'center',
          padding: '0.75rem 1.5rem',
          boxShadow: '0 2px 8px 0 rgba(0,0,0,0.04)'
        }}>
          <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginRight: '12px'}}>
            <circle cx="11" cy="11" r="8" stroke="#FFEB3B" strokeWidth="2" />
            <path d="M20 20L17 17" stroke="#FFEB3B" strokeWidth="2" strokeLinecap="round" />
          </svg>
          <input
            type="text"
            placeholder="Search for answers......"
            style={{
              border: 'none',
              outline: 'none',
              background: 'transparent',
              fontSize: '1.1rem',
              color: '#444',
              width: '100%',
              fontFamily: 'inherit',
              fontWeight: 400
            }}
          />
        </div>
      </div>
      {/* Getting Started FAQ Accordion Section */}
      <div className="w-full max-w-8xl mx-auto mb-12 px-2 md:px-4 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center justify-center" style={{ width: 40, height: 40, borderRadius: 12, background: '#E0EDFF' }}>
            <img src={gettingStartedIcon} alt="Getting Started" style={{ width: 24, height: 24, objectFit: 'contain' }} />
          </span>
          <span className="text-lg sm:text-xl font-bold" style={{fontFamily: 'Roboto Slab, serif'}}>Getting Started</span>
        </div>
        <Accordion />
      </div>
      {/* About the Test FAQ Accordion Section */}
      <div className="w-full max-w-8xl mx-auto mb-12 px-2 md:px-4 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center justify-center" style={{ width: 40, height: 40, borderRadius: 12, background: '#F3E8FF' }}>
            <img src={personalityIcon} alt="About the Test" style={{ width: 24, height: 24, objectFit: 'contain', filter: 'invert(16%) sepia(97%) saturate(7472%) hue-rotate(265deg) brightness(0.95) contrast(1.1)' }} />
          </span>
          <span className="text-lg sm:text-xl font-bold" style={{fontFamily: 'Roboto Slab, serif'}}>About the Test</span>
        </div>
        <AboutTestAccordion />
      </div>
      {/* Results & Reports FAQ Accordion Section */}
      <div className="w-full max-w-8xl mx-auto mb-12 px-2 md:px-4 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center justify-center" style={{ width: 40, height: 40, borderRadius: 12, background: '#DCFCE7' }}>
            <img src={accuracyIcon} alt="Results & Reports" style={{ width: 24, height: 24, objectFit: 'contain', filter: 'invert(62%) sepia(97%) saturate(749%) hue-rotate(85deg) brightness(1.1) contrast(1.2)' }} />
          </span>
          <span className="text-lg sm:text-xl font-bold" style={{fontFamily: 'Roboto Slab, serif'}}>Results & Reports</span>
        </div>
        <ResultsAccordion />
      </div>

      {/* Privacy & Security FAQ Accordion Section */}
      <div className="w-full max-w-8xl mx-auto mb-12 px-2 md:px-4 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center  justify-center" style={{ width: 40, height: 40, borderRadius: 12, background: '#FEE2E2' }}>
            <img src={require('../assets/guard red.png')} alt="Privacy & Security" style={{ width: 29, height: 20, objectFit: 'contain', filter: 'invert(14%) sepia(100%) saturate(7480%) hue-rotate(-1deg) brightness(1.05) contrast(1.2)' }} />
          </span>
          <span className="text-lg sm:text-xl font-bold" style={{fontFamily: 'Roboto Slab, serif'}}>Privacy & Security</span>
        </div>
        <PrivacyAccordion />
      </div>

      {/* Technical Support FAQ Accordion Section */}
      <div className="w-full max-w-8xl mx-auto mb-12 px-2 md:px-4 lg:px-8">
        <div className="flex items-center gap-3 mb-4">
          <span className="flex items-center justify-center" style={{ width: 40, height: 40, borderRadius: 12, background: '#FFF7ED' }}>
            <img src={happyUsersIcon} alt="Technical Support" style={{ width: 24, height: 24, objectFit: 'contain', filter: 'invert(53%) sepia(99%) saturate(2000%) hue-rotate(-15deg) brightness(1.1) contrast(1.2)' }} />
          </span>
          <span className="text-lg sm:text-xl font-bold" style={{fontFamily: 'Roboto Slab, serif'}}>Technical Support</span>
        </div>
        <TechnicalSupportAccordion />
      </div>

      {/* Still Have Questions? CTA Section */}
      <div className="w-full flex justify-center mb-16 px-2 md:px-4 lg:px-8" style={{minHeight: 220, marginTop: 32}}>
        <div className="shadow-lg w-full max-w-8xl" style={{
          borderRadius: 8,
          opacity: 1,
          background: 'linear-gradient(90deg, #F5FAFF 0%, #F8F6FF 100%)',
          boxShadow: '0 16px 40px 0 rgba(80, 80, 120, 0.18), 0 2px 8px 0 rgba(0,0,0,0.07)',
          padding: '2.5rem 1.5rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
        }}>
          <div className="flex flex-col items-center justify-center">
            <span className="flex items-center justify-center mb-4" style={{ width: 56, height: 56, borderRadius: 16, background: '#B39DDB' }}>
              <img src={require('../assets/chat.png')} alt="Chat Icon" style={{ width: 32, height: 32, objectFit: 'contain', filter: 'brightness(0) invert(1)' }} />
            </span>
            <h2 className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-2 text-center" style={{fontFamily: 'Roboto Slab, serif'}}>Still Have Questions?</h2>
            <p className="text-gray-600 text-center mb-6 max-w-md sm:max-w-xl" style={{fontFamily: 'Roboto Slab, serif', fontWeight: 400}}>
              Our friendly support team is available 24/7 to help you with any questions or concerns. We're committed to providing you with the best possible experience.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center w-full">
              <button className="flex items-center gap-2 px-5 py-2 rounded-lg font-medium shadow-md w-full sm:w-auto" style={{background: 'linear-gradient(90deg, #E94057 0%, #8A2387 100%)', color: '#fff', fontFamily: 'Roboto Slab, serif', boxShadow: '0 2px 8px 0 rgba(233,64,87,0.12)'}}>
                <svg width="24" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="24" height="16" rx="4" fill="none"/>
                  <path d="M5.5 4V12C5.5 13.1046 6.39543 14 7.5 14H16.5C17.6046 14 18.5 13.1046 18.5 12V4C18.5 2.89543 17.6046 2 16.5 2H7.5C6.39543 2 5.5 2.89543 5.5 4Z" stroke="#fff" strokeWidth="1.2"/>
                  <path d="M5.5 4L12 9L18.5 4" stroke="#fff" strokeWidth="1.2"/>
                </svg>
                Contact Support
              </button>
              <button className="flex items-center gap-2 px-5 py-2 rounded-lg font-medium shadow-md w-full sm:w-auto" style={{background: '#fff', color: '#222', fontFamily: 'Roboto Slab, serif', border: '1.5px solid #E0E7FF', boxShadow: '0 2px 8px 0 rgba(0,0,0,0.06)'}}>
                <img src={require('../assets/chat.png')} alt="Live Chat" style={{ width: 20, height: 20, objectFit: 'contain' }} />
                Live Chat
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    {/* Gradient line above footer */}
    <div className="w-full flex justify-center" style={{marginBottom: -8, marginTop: 32}}>
      <div style={{width: '100%', maxWidth: 1500, height: 5, borderRadius: 6, background: 'linear-gradient(90deg, #F472B6 0%, #EAB308 33%, #6366F1 100%)'}} />
    </div>
    <Footer />
  </div>
);

function PrivacyAccordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const privacyFaqs = [
    {
      question: 'How do you protect my personal information?',
      answer: 'We use industry-standard encryption and strict access controls to keep your personal information safe.'
    },
    {
      question: 'What data do you collect during the test?',
      answer: 'We only collect data necessary to provide accurate results and improve our services. Your data is never sold.'
    },
    {
      question: 'Can employers or others access my results?',
      answer: 'No, your results are private and only accessible to you unless you choose to share them.'
    },
  ];
  return (
    <div className="space-y-4">
      {privacyFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}


function TechnicalSupportAccordion() {
  const [openIdx, setOpenIdx] = useState(null);
  const supportFaqs = [
    {
      question: "The test isn't loading properly. What should I do?",
      answer: "Try refreshing the page or clearing your browser cache. If the problem persists, contact our support team."
    },
    {
      question: "Can I take the test on my mobile device?",
      answer: "Yes, our platform is fully responsive and works on all modern mobile devices."
    },
    {
      question: "I lost my results. Can you help me recover them?",
      answer: "If you created an account, you can log in to view your results. Otherwise, please contact support for assistance."
    },
    {
      question: "How do I contact customer support?",
      answer: "You can reach our customer support team via the Contact page or by emailing support@example.com."
    },
  ];
  return (
    <div className="space-y-4">
      {supportFaqs.map((faq, idx) => (
        <div key={idx} className="bg-white rounded-lg shadow-sm border border-gray-100">
          <button
            className="w-full flex justify-between items-center px-5 py-4 text-left focus:outline-none"
            onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
            style={{fontFamily: 'inherit', fontWeight: 500, fontSize: '1rem'}}
          >
            <span>{faq.question}</span>
            <svg
              className={`w-5 h-5 text-gray-400 transform transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}
              fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>
          {openIdx === idx && (
            <div className="px-5 pb-4 text-gray-700 text-sm border-t border-gray-100" style={{fontFamily: 'inherit'}}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}}

export default FAQ;


